export const SCRIPT_IDS = {
  STORE: 'store',
  MESSAGES: 'messages',
  GRIFFIN: 'griffin',
  NAVIGATION: 'navigation',
}

export const DEFAULT_LOCALE = {
  LANGUAGE: 'en',
  COUNTRY: 'US',
}

export const TEST_OPTIONS_HEADER = 'X-PP-Test-Options'

export const AMOUNT_TYPES = {
  any: 'any',
  at_least: 'at_least',
  exactly: 'exactly',
}

export const GRADIENT_COLORS = {
  blue: 'blue',
  purple: 'purple',
  fuchsia: 'fuchsia',
  red: 'red',
  teal: 'teal',
  gray: 'gray',
  green: 'green',
  sky: 'sky',
  pink: 'pink',
  orange: 'orange',
}

export const DEFAULT_GRADIENT_COLOR = 'teal'

export const DAYS_THRESHOLD = 28

export const COVER_IMAGE_MAX_TOTAL_SIZE = 1600
export const CROWDFUNDING_COVER_IMAGE_MAX_TOTAL_SIZE = 5000000
export const CROWDFUNDING_GOAL_AMOUNT = {
  MIN_AMOUNT: 1,
  MAX_AMOUNT: 20000,
}
export const CROWDFUNDING_CAMPAIGN_MAX_DAYS = 30

export const COVER_IMAGE_UPLOAD_ERRORS = {
  FILE_INVALID_TYPE: 'file-invalid-type',
  FILE_TOO_LARGE: 'file-too-large',
  FILE_TOO_SMALL: 'file-too-small',
  TOO_MANY_FILES: 'too-many-files',
}

export const CONTRIBUTIONS_PAGE_SIZE = {
  mobile: 5,
  desktop: 10,
}

export const WALLET_SETTINGS_SERV_FAIL = 'WALLET_SETTINGS_SERV_FAIL'

export const MIN_CONTRIBUTOR_ROW_HEIGHT = '1.6em'

export const MIN_ACTIVITY_ROW_HEIGHT = '1.1em'

export const USR_TXNS_COOKIE_EXPIRY = 15 * 60 * 1000

export const UNDER_REVIEW_ERROR = 'UNDER_REVIEW'

export const STORAGE_EXPIRATION = 1000 * 60 * 30 // 30 mins

export const FUNDING_SOURCES = {
  HOLDING: 'HOLDING',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
}

export const CFS_INTENT = 'MONEYPOOLS'
export const CFS_ELIGIBILITY_URL = '/myaccount/bundle/product-eligibility'
export const BRAZIL_ELIGIBILITY_URL = '/policy/hub/cip'

export const CIP_FLOW_URL = {
  HOMEINFO_URL: '/myaccount/info/flow/educate',
  RETURN_URL: '/myaccount/summary',
  ENTRY_POINT: 'POOLS',
}

export const AUTH_STATES = {
  LOGGEDIN: 'LOGGEDIN',
  IDENTIFIED: 'IDENTIFIED',
}

export const ACCOUNT_TYPES = {
  PERSONAL: 'PERSONAL',
  PREMIER: 'PREMIER',
  BUSINESS: 'BUSINESS',
}

export const SUBSCRIPTION_TYPES = {
  WALLET: 'WALLET',
  CASH: 'CASH',
  CASH_PLUS: 'CASH_PLUS',
}
export const FEATURES_TYPES = {
  CROSS_BORDER: 'SEND_MONEY_CROSS_BORDER_FRIENDS_AND_FAMILY',
  DOMESTIC: 'SEND_MONEY_DOMESTIC_FRIENDS_AND_FAMILY',
}
export const FLOW_DETAILS = {
  FEATURE: 'PERSONAL',
  SUB_FLOW: 'CONTRIBUTE',
}

export const EXPERIMENTS = {
  // all experiments created with Elmo, unless otherwise stated
  MONEY_POOLS_MAIN: {
    TREATMENT: 'money_pools_main_treatment',
    CONTROL: 'money_pools_main_control',
  },
  P2P_GUEST_FF: {
    TREATMENT: 'p2p_guest_friends_and_family_treatment',
    CONTROL: 'p2p_guest_friends_and_family_control',
  },
  CFPB: {
    // NOTE: these are from PXP
    TREATMENT: 'cfpb_paypal_cash_us_treatment',
    CONTROL: 'cfpb_paypal_cash_us_control',
  },
  MONEY_POOLS_CROWDFUNDING: {
    TREATMENT: 'Trmt_money_pools_crowdfunding_1',
    CONTROL: 'Ctrl_money_pools_crowdfunding',
  },
  CROWD_FUNDING_GUEST_DONATION: {
    TREATMENT: 'Trmt_crowdfunding_guest_donation_1',
    CONTROL: 'Ctrl_crowdfunding_guest_donation',
  },
  AUCIP: {
    TREATMENT: 'PAYPALWALLET_FEATURES_RAMP_TRMT',
    CONTROL: 'PAYPALWALLET_FEATURES_RAMP_CTRL',
  },
}

// We use an experiment to check whether the guest user can do guest F&F
// and we'll check this list of countries to see if the pool owner can receive
// guest contributions. Elmo was not allowing us to spoof the security context in
// prod.
export const guestEnabledCountries = [
  'US',
  'AT',
  'BE',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LI',
  'LT',
  'LU',
  'MT',
  'NL',
  'NO',
  'PL',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
]

/* ------------- */

export const ELMO_RESOURCE_NAME = [
  'main:walletweb:transfer',
  'main:paypalwallet:feature',
].join(',')
export const ELMO_CROWDFUNDING_RESOURCE_NAME = 'main:crowdfunding:pool'

export const PXP_PAGE_NAME = 'cfpb_paypal_cash_us'

export const POOLS_CAMPAIGN_TYPES = {
  PUBLIC_MONEY_POOL: 'PUBLIC_MONEY_POOL',
  CROWD_FUNDING: 'CROWD_FUNDING',
}

export const CROWD_FUNDING_HOME_URI = '/generosity-network'
export const CIP_ELIGIBILITY_CODES = {
  USER_REACHED_CAMPAIGN_CREATION_LIMIT: 'USER_REACHED_CAMPAIGN_CREATION_LIMIT',
  RUGS_CHECK_HIT_WITH_DC_NEED_MORE_DATA: 'NEED_MORE_DATA',
  RUGS_CHECK_HIT_WITH_DC_MANUAL_REVIEW: 'MANUAL_REVIEW',
  RUGS_CHECK_HIT_WITH_DC_PENDING_VERIFICATION: 'PENDING_VERIFICATION',
  RUGS_CHECK_HIT_WITH_DC_PENDING: 'PENDING',
  RUGS_CHECK_HIT_FAILED: 'RUGS_CHECK_HIT_FAILED',
  RUGS_CHECK_FAILED: 'RUGS_CHECK_FAILED',
}

export const NO_DESCRIPTION_ERRORS = ['REJECTED', 'RUGS_CHECK_HIT_FAILED']

export const DEXTER_SPECIFIC_ERRORS = [
  'REJECTED',
  'AUTO_VERIFICATION_FAILED',
  'NOT_APPLICABLE',
  'SERVICE_UNAVAILABLE',
  'INVALID_REQUEST',
]

export const CIP_ERROR_CODE = [
  'REJECTED',
  'SERVICE_UNAVAILABLE',
  'MANUAL_REVIEW',
  'AUTO_VERIFICATION_FAILED',
  'NOT_APPLICABLE',
]

export const ELIGIBILITY_STATUS = {
  INELIGIBLE: 'INELIGIBLE',
  ELIGIBLE: 'ELIGIBLE',
  UNKNOWN: 'UNKNOWN',
}

export const VERIFICATION_FLOW = {
  RUGS: 'RUGS',
  DEXTER: 'DEXTER',
}
// TIP: if you ever need to add more to these, you can do something like below:
// const PXP_PAGE_NAME = [
// 	'cfpb_paypal_cash_us',
// 	'some:other:page',
// ].join(',')

/* ------------- */
